import { cn } from "@/lib/utils";
import type { DashboardPeriod } from "./types";
import { DASHBOARD_PERIODS } from "./utils";

export interface DashboardPeriodSwitcherProps {
  period: DashboardPeriod;
  onPeriodChange: (period: DashboardPeriod) => void;
  labels: Record<DashboardPeriod, string>;
  size?: "sm" | "md";
  className?: string;
}

export function DashboardPeriodSwitcher({
  period,
  onPeriodChange,
  labels,
  size = "md",
  className,
}: DashboardPeriodSwitcherProps) {
  const heightClass = size === "sm" ? "h-8" : "h-9";
  const padClass = size === "sm" ? "px-2.5 text-[11px]" : "px-3 text-xs";
  return (
    <div
      role="tablist"
      aria-label="Dönem"
      className={cn(
        "inline-flex items-center gap-0.5 rounded-full border border-biz-border bg-biz-muted/60 p-0.5",
        className,
      )}
    >
      {DASHBOARD_PERIODS.map((p) => {
        const active = p === period;
        return (
          <button
            key={p}
            role="tab"
            type="button"
            aria-selected={active}
            onClick={() => onPeriodChange(p)}
            className={cn(
              heightClass,
              padClass,
              "inline-flex items-center justify-center rounded-full font-semibold transition-all duration-150",
              "biz-focus-ring",
              active
                ? "bg-biz-surface-elevated text-biz-foreground biz-shadow-sm"
                : "text-biz-foreground-muted hover:text-biz-foreground",
            )}
          >
            {labels[p]}
          </button>
        );
      })}
    </div>
  );
}
